import angular = require("angular");
import TPL = require("templates");

export class InviteGuestsDirective {

  template = TPL.contentDirectives.inviteGuests;
  scope = {
    params: "=params",
  };
  link;
  session;

  constructor(session, $log) {
    this.session = session;

    this.link = (scope, el, attrs) => {
      scope.tags = [];
      scope.emailText = "";
      scope.placeholder = "Insert your friends emails";

      scope.vm = {

        getTags: () => {
          return scope.tags;
        },

        canSend: () => {
          return scope.tags.length != 0;
        },

        isValidEmail: (value) => {
            if (!value) {
                return false;
            }
            // Email Regex used by ASP.Net MVC
            var regex = /^[\w-]+(\.[\w-]+)*@([a-z0-9-]+(\.[a-z0-9-]+)*?\.[a-z]{2,6}|(\d{1,3}\.){3}\d{1,3})(:\d{4})?$/i;
            return regex.exec(value) != null;
        },

        inviteGuests: (form) => {
          $log.debug("inviteGuests");

          angular.forEach(scope.tags, (tag) => {
            var email = tag.text;
            var emails = [];
            if(scope.vm.isValidEmail(email)) {
              $log.debug("Valid email:" + email);
              emails.push(email);
            } else {
              $log.debug("Invalid email:" + email);
            }

            if(emails.length > 0) {
              this.session.sendInvitations("guest-invitation",emails, scope.emailText).then(() => {
                scope.params.onSuccessCallback();
              });
            } else {

            }
          });

          return true;
        }
      }
    };

  }

  static factory() {
    var tmp = (a, b) => new InviteGuestsDirective(a, b);
    tmp.$inject = ["session", "$log"];
    return tmp;
  }

}



/** WEBPACK FOOTER **
 ** ./src/scripts/directives/content/inviteGuests.ts
 **/